import { sessaoFetch } from '@/service/fetch'

export async function verificaFila (dados) {
  let retorno = await sessaoFetch('consig', '/Usuarios/ChecarFila/' + dados.chave, 'GET')
  return retorno.instancia
}



// WEBPACK FOOTER //
// ./src/api/filas.js